import type { ObligationType } from '@risksmart-app/domain/src/types/consts/obligation-type';
import type { ObligationsByTypeResponse } from '@risksmart-app/trpc/src/types';
import type { GetObligationsByTypeQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationsByTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, type StrictMappedGraphQLSelection } from 'src/utils';

type UseGetObligationsByTypeArgs = { type: ObligationType };

const mapToGraphQL = (
  data: ObligationsByTypeResponse
): StrictMappedGraphQLSelection<GetObligationsByTypeQuery> => ({
  obligation: data,
});

export const useGetObligationsByType = createQueryHook<
  UseGetObligationsByTypeArgs,
  ObligationsByTypeResponse,
  GetObligationsByTypeQuery
>({
  trpcQueryOptions: (trpc, { type }) =>
    trpc.frontend.obligation.obligationsByType.queryOptions({ type }),
  mapTrpcDataToGraphQL: mapToGraphQL,
  graphqlDocument: GetObligationsByTypeDocument,
  graphqlVariables: ({ type }) => ({ type }),
});
